import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetCompanies } from '@/hooks/useGetCompanies';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';

const { useWatch } = Form;

export function CompanyFormItem() {
	const organization_id = useWatch('organization_id');
	const { data: companies = [] } = useGetCompanies({ organization_id });

	return (
		<FormItemWrapper
			name="company_id"
			label={<LabelMediumRegular>{I18n.get('Industrial site')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<SelectOptions allowClear loading={false} options={companies} placeholder={I18n.get('Industrial site')} />
		</FormItemWrapper>
	);
}
